import { useEffect } from "react";

export const Seo = ({ title, description, noindex = false }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) {
      robots.setAttribute(
        "content",
        noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"
      );
    }
  }, [title, description, noindex]);
  return null;
};
